import {Constants} from "../constants/Constants";

export default class UsersManager {

    static getLoggedInUser(): string | undefined {
        let loggedInUserString = localStorage.getItem("logged_in_user")
        if (!loggedInUserString) {
            return undefined
        }
        return loggedInUserString
    }

    static getLoggedInUserFromSessionStorage(): string | undefined {
        let loggedInUserString = sessionStorage.getItem("logged_in_user")
        if (!loggedInUserString) {
            return undefined
        }
        return loggedInUserString
    }

    static deleteLoggedInUser() {
        localStorage.removeItem("logged_in_user");
    }

    static saveLoggedInUser(user: any) {
        if (typeof user !== 'string') {
            user = JSON.stringify(user)
        }
        let existingUserString = UsersManager.getLoggedInUser()
        let rememberMe = undefined;
        if (existingUserString !== undefined) {
            let existingUser = JSON.parse(existingUserString as string)
            rememberMe = existingUser[Constants.REMEMBER_ME]
        }
        let newUser = JSON.parse(user)
        if (rememberMe !== undefined) {
            newUser[Constants.REMEMBER_ME] = rememberMe;
        }
        localStorage.setItem("logged_in_user", JSON.stringify(newUser));
        sessionStorage.setItem("logged_in_user", JSON.stringify(newUser));
    }

    static hasRolled(): boolean {
        return localStorage.getItem("has_rolled") != null
    }

    static setHasRolled() {
        localStorage.setItem("has_rolled", "rolled");
    }
    
}